(function () {
  function animateCount(element) {
    var target = parseInt(element.getAttribute('data-target'), 10);

    if (isNaN(target)) return;

    var duration = 1400;
    var startTime = null;

    element.textContent = '0';

    function step(timestamp) {
      if (!startTime) startTime = timestamp;

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var easedProgress = 1 - Math.pow(1 - progress, 3);
      var currentValue = Math.floor(target * easedProgress);

      element.textContent = currentValue.toString();

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        element.textContent = target.toString();
      }
    }

    window.requestAnimationFrame(step);
  }

  function initScienceStats(section) {
    var counters = section.querySelectorAll('[data-count-up]');

    if (!counters.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            counters.forEach(function (counter) {
              animateCount(counter);
            });
          } else {
            counters.forEach(function (counter) {
              counter.textContent = '0';
            });
          }
        });
      },
      {
        threshold: 0.45
      }
    );

    observer.observe(section);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-el-science-stats]');

    sections.forEach(function (section) {
      initScienceStats(section);
    });
  });
})();